import 'bee-notification/build/Notification.css'
export * from 'bee-notification';
export { default } from 'bee-notification';


// WEBPACK FOOTER //
// ./src/components/bee/notification/index.js